import { HTTP } from '../http'

export const CONFIGURATOR_API = {
  login: async (url, user) => {
    return HTTP.post(
      url + 'user/login',
      user
    )
  },
  checkAuth: async (url, token, name) => {
    return HTTP.post(
      url + 'user/check',
      {
        name: name,
        token: token
      }
    )
  },
  logout: async (url, token, name) => {
    return HTTP.post(
      url + 'user/logout/' + name,
      {},
      { headers: { 'user-token': token } }
    )
  },

  getGlobalSettings: async (url, token) => {
    return HTTP.get(
      url + 'common',
      { headers: { 'user-token': token } }
    )
  },

  setGlobalSettings: async (url, token, data) => {
    return HTTP.post(
      url + 'common',
      data,
      { headers: { 'user-token': token } }
    )
  },

  getComponents: async (url, token) => {
    return HTTP.get(
      url + 'components',
      { headers: { 'user-token': token } }
    )
  },

  getComponent: async (url, token, component) => {
    return HTTP.get(
      url + 'component/' + component,
      { headers: { 'user-token': token } }
    )
  },

  setComponent: async (url, token, component, data) => {
    return HTTP.post(
      url + 'component/' + component,
      data,
      { headers: { 'user-token': token } }
    )
  },

  getInstance: async (url, token, component, instance) => {
    return HTTP.get(
      url + 'component/' + component + '/instance/' + instance,
      { headers: { 'user-token': token } }
    )
  },

  setInstance: async (url, token, component, instance, data) => {
    return HTTP.post(
      url + 'component/' + component + '/instance/' + instance,
      data,
      { headers: { 'user-token': token } }
    )
  },

  getFiles: async (url, token) => {
    return HTTP.get(
      url + 'files',
      { headers: { 'user-token': token } }
    )
  },

  addFiles: async (url, token, file) => {
    const formData = new FormData()
    formData.set('file', file)
    return HTTP.post(
      url + 'files',
      formData,
      {
        headers: {
          'user-token': token,
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  },
  deleteFiles: async (url, token, name) => {
    return HTTP.delete(
      url + 'files/' + name,
      { headers: { 'user-token': token } }
    )
  },
  deleteInstance: async (url, token, component, instance) => HTTP.delete(
    `${url}component/${component}/instance/${instance}`,
    { headers: { 'user-token': token } }
  )
}
